import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=3e1f33fa&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=3e1f33fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1f33fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e1f33fa')) {
      api.createRecord('3e1f33fa', component.options)
    } else {
      api.reload('3e1f33fa', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=3e1f33fa&scoped=true&", function () {
      api.rerender('3e1f33fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2i3xrAAFTr1pN/JS/comp/PopupBox.vue"
export default component.exports